export default __webpack_public_path__ + "static/b3ca6462-e5b3-4cfd-9c86-69bd1444273f-da3a29cb7bb23462129ecf9faed408a9.ttf";